/*!
 * I Giardini di Giulia · Premium Homepage Interactions
 * v2.0 - Performance-first, accessibility-first
 */
(function() {
  'use strict';

  // Skip se ridotto movimento
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ============ REVEAL ON SCROLL ============
  function initReveal() {
    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      document.querySelectorAll('.gg-reveal').forEach(function(el) {
        el.classList.add('gg-visible');
      });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gg-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -80px 0px'
    });
    document.querySelectorAll('.gg-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ============ HERO PARALLAX (sottile, performante) ============
  function initParallax() {
    if (prefersReducedMotion) return;
    var heroBg = document.querySelector('.gg-hero__bg');
    if (!heroBg) return;

    var ticking = false;
    var lastY = 0;

    function update() {
      if (lastY < 1000) {
        heroBg.style.transform = 'translate3d(0, ' + (lastY * 0.25) + 'px, 0)';
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      lastY = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // ============ TRUSTPILOT LAZY LOAD ============
  // Carica lo script Trustpilot solo quando l'utente è vicino al widget
  function initTrustpilot() {
    var widget = document.querySelector('.trustpilot-widget');
    if (!widget) return;

    var loaded = false;
    function loadScript() {
      if (loaded) return;
      loaded = true;
      var s = document.createElement('script');
      s.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      s.async = true;
      document.head.appendChild(s);
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            loadScript();
            obs.disconnect();
          }
        });
      }, { rootMargin: '300px' });
      obs.observe(widget);
    } else {
      // Fallback
      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadScript, { timeout: 4000 });
      } else {
        setTimeout(loadScript, 3000);
      }
    }
  }

  // ============ INIT ============
  function init() {
    initReveal();
    initParallax();
    initTrustpilot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
